import React from "react";
import { DetailsCalculatorProvider, type CalculatorSnapshot } from "./DetailsCalculatorProvider";

export interface DetailsCalculatorBridgeProps {
  carId: number;
  pageType: string;
  literals: any;
  reservation: boolean;
  availableAttracivenessLevels: any;
  currentLevel: string;
  currentProvision: number;
  levelChangeHandler: (value: string) => void;
  handleContactModal: (url: string) => void;
  contactUrl?: (url: string) => void;
  setToggleRetailModalForm: () => void;
  disableApplication: boolean;
  isProgramMyElectric: boolean;
  isLeasingAvailable: boolean;
  isRentAvailable: boolean;
  isCashAvailable: boolean;
  isElectric: boolean;
  totalPriceNetto: number;
  totalPriceBrutto: number;
  attractivenessLevel?: string | null;
  templateId?: string | null;
  vendorType?: string | null;
  login?: string | null;
  onActiveTabChange?: (tab: number) => void;
  onCalculatorSnapshot?: (snapshot: CalculatorSnapshot) => void;
  children: React.ReactNode;
}

/** Wraps details page sections that share calculator state via context. */
export function DetailsCalculatorBridge(props: DetailsCalculatorBridgeProps) {
  const { children, ...providerParams } = props;

  return (
    <DetailsCalculatorProvider
      carId={providerParams.carId}
      pageType={providerParams.pageType}
      isRentAvailable={providerParams.isRentAvailable}
      isLeasingAvailable={providerParams.isLeasingAvailable}
      isCashAvailable={providerParams.isCashAvailable}
      isElectric={providerParams.isElectric}
      literals={providerParams.literals}
      attractivenessLevel={providerParams.attractivenessLevel}
      templateId={providerParams.templateId}
      vendorType={providerParams.vendorType}
      login={providerParams.login}
      onActiveTabChange={providerParams.onActiveTabChange}
      onContactUrl={providerParams.contactUrl}
      onCalculatorSnapshot={providerParams.onCalculatorSnapshot}
      totalPriceBrutto={providerParams.totalPriceBrutto}
    >
      {children}
    </DetailsCalculatorProvider>
  );
}
